import { render, staticRenderFns } from "./ExtendModal.vue?vue&type=template&id=3bf0cb16"
import script from "./ExtendModal.vue?vue&type=script&lang=ts"
export * from "./ExtendModal.vue?vue&type=script&lang=ts"
import style0 from "./ExtendModal.vue?vue&type=style&index=0&id=3bf0cb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports